<template>

  <aside class="column is-2 is-narrow-mobile is-fullheight section is-hidden-mobile">
    <img src="/static/assets/img/logo.png" alt="logo" class="logo" style="margin-top:0;height: 40px;">
    <p class="menu-label is-hidden-touch">Navigation</p>
    <ul class="menu-list">
      <li>
        <router-link to="/">
          <span class="icon"><i class="fa fa-home"></i></span> Alerts <span v-if="getAlertsCount>0" class="has-text-danger">({{ getAlertsCount }})</span>
        </router-link>
      </li>
      <li>
        <router-link to="/topics/">
          <span class="icon"><i class="fa fa-table"></i></span> My Topics
        </router-link>

        <!--     <ul>
               <li v-for="(key,idx) in recentTopics" :key="'t'+idx">
                 <router-link to="/">
                   <span class="icon is-small"><i class="fa fa-link"></i></span> {{ key.title }}
                 </router-link>
               </li>


             </ul> -->
      </li>


      <li>
        <router-link to="/account/">
          <span class="icon"><i class="fa fa-info"></i></span> My account
        </router-link>
      </li>


      <li>
        <a href="#" class="">
          <span class="icon"><i class="fa fa-info"></i></span> Logout
        </a>
      </li>

    </ul>
  </aside>

</template>

<script>

import {mapGetters} from 'vuex'

export default {
  name: "Sidebar",

  data() {
    return {}
  },

  computed: {

    ...mapGetters({
      getAlertsCount: 'getAlertsCount'
    })
  }


}


</script>

<style scoped>

</style>
